module.exports = __webpack_public_path__ + "static/img/baiyunshan.b1f9f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/friends/baiyunshan.png
// module id = 97MC
// module chunks = 1